import React from "react";
import { Col, Row, Input } from "antd";
import OfferTypes from "./OfferTypes";
const Search = Input.Search;

const TopPanel = props => {
  const {
    typesList,
    onChangeTypeList,
    onChangeSearch,
    handleSearchOffers,
    searchFieldValue,
    typeListValue
  } = props;

  return (
    <div className="b-table-filters">
      <Row>
        <Col span={18}>
          <div className="orders__states">
            <OfferTypes
              typesList={typesList}
              value={typeListValue}
              onChangeTypeList={onChangeTypeList}
            />
          </div>
        </Col>
        <Col span={6}>
          <Search
            placeholder="Поиск по предложениям"
            onChange={onChangeSearch}
            allowClear={true}
            value={searchFieldValue}
            onSearch={handleSearchOffers}
            style={{ width: "100%" }}
          />
        </Col>
      </Row>
    </div>
  );
};

export default TopPanel;
